import { Request } from './Request';

export interface ICreateGroupParams {
  name: string;
}

export interface ICreateGroupResult {
}

export class CreateGroupRequest extends Request<ICreateGroupParams, ICreateGroupResult> {
  constructor(params: ICreateGroupParams) {
    super('createGroup', params);
  }
}
